export type VisiblePageItem = {
    page: number
    label: number | '…'
}

export const getVisiblePages = (currentPage: number, totalPages: number): number[] => {
    if (totalPages < 1) {
        return []
    }

    if (totalPages < 9) {
        return Array.from({ length: totalPages }, (_, index) => index + 1)
    }

    let edgePages: number[] = []

    if (currentPage === 1) {
        edgePages = [currentPage + 2]
    } else if (currentPage === totalPages) {
        edgePages = [currentPage - 2]
    }
    const pages = new Set([1, totalPages, currentPage - 1, currentPage, currentPage + 1, ...edgePages])

    return [...pages].filter((page) => page >= 1 && page <= totalPages).sort((left, right) => left - right)
}

export const getVisiblePageItems = (currentPage: number, totalPages: number): VisiblePageItem[] => {
    const pages = getVisiblePages(currentPage, totalPages)
    const middlePages = [Math.round((currentPage + 1) / 2), Math.round((currentPage + totalPages) / 2)]

    return pages.flatMap((page, index) => {
        const nextPage = pages[index + 1]

        if (nextPage !== undefined && nextPage - page > 1) {
            const middlePage = middlePages.find((candidate) => candidate > page && candidate < nextPage)

            return [
                { page, label: page },
                { page: middlePage ?? Math.round((page + nextPage) / 2), label: '…' },
            ]
        }

        return [{ page, label: page }]
    })
}
